(function ($) {

  function ready() {

    $('#contactDropdown').click(function () {
      $('#contactDropdown ul.dropdown-menu').toggle();
      $('#contactDropdown a').toggleClass('dropup');
      $('#contactDropdown div.phone-section').toggleClass('paint-phone');
      $('#contactDropdown ul.dropdown-menu').toggleClass('paint-phone');
      $('#contactDropdown i').toggleClass('uxicon-chevron-up-lt');
      $('#contactDropdown i').toggleClass('uxicon-chevron-down-lt');
    });

  }

  $(document).ready(ready);

}(jQuery));
